// extracted by mini-css-extract-plugin
module.exports = {"themecolor":"#D89F55","panelboxshadow":"0px 1px 2px 0px rgba(16,29,72,0.13)","sectionGap":"12px"};